import i18n from '@/lib/i18n';

/**
 * Fenêtres de filtrage temporel, en jours. L'id d'option est la valeur en
 * chaîne : c'est ce que les formulaires envoient à l'API.
 */
export const PERIOD_DAYS = [15, 30, 60, 90, 180];

/**
 * Options du filtre « Période », libellés traduits.
 *
 * Mutualisé : les filtres dossiers, procédures et rapports portaient chacun une
 * copie mot pour mot de la même liste, avec cinq libellés en dur. Seul
 * « Depuis le début » avait été traduit lors de la migration — les cinq autres
 * n'ont ni accent ni mot-outil et échappaient à la détection.
 *
 * Fonction et non constante de module : le libellé est recalculé à chaque appel
 * et suit donc la langue active, sans dépendre du rechargement de page opéré par
 * setLocale().
 *
 * @returns {{ id: string, name: string }[]}
 */
export function getPeriodOptions() {
    return [
        ...PERIOD_DAYS.map((days) => ({
            id: String(days),
            name: i18n.t('common:period.lastNDays', { count: days }),
        })),
        { id: 'all', name: i18n.t('common:period.sinceBeginning') },
    ];
}
